<template>
  <b-modal
    id="modal-lg"
    v-model="conditionFacility"
    hide-footer
    hide-header
    centered
    size="lg"
    no-close-on-backdrop
    @hide="onHide"
  >
    <form @submit.prevent="onSubmitFacility">
      <validation-provider
        #default="{ errors }"
        name="Facility"
        rules="required"
      >
        <b-form-group label="Facility" label-for="facility">
          <treeselect
            id="gender"
            v-model="dataFacility"
            :options="optionsFacility"
            :normalizer="normalizer"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </b-form-group>
      </validation-provider>
      <div class="d-flex justify-content-end mt-2">
        <b-button
          type="button"
          class="mr-2"
          variant="outline-danger"
          @click="onHide"
        >
          {{ $t("Cancel") }}
        </b-button>
        <b-button variant="primary" type="submit" :disabled="loading">
          <span v-if="!loading">Change</span>
          <span v-else>
            <SpinnerLoading />
          </span>
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { BButton, BModal, BFormGroup } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import SpinnerLoading from "@/components/SpinnerLoading";
import NotificationMixin from "@/mixins/NotificationMixin";

import axiosF from "@/core/services/apiInsurance/admin/facilities";
import axiosA from "@/core/services/apiInsurance/appointment/actions";
export default {
  components: {
    BButton,
    BModal,
    BFormGroup,

    ValidationProvider,
    ValidationObserver,

    SpinnerLoading,
  },
  data() {
    return {
      conditionFacility: true,
      dataFacility: this.appointmentById.facilities_id,
      optionsFacility: [],
      loading: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
    };
  },
  props: {
    appointmentById: {
      type: Object,
      required: true,
    },
  },
  mixins: [NotificationMixin],
  mounted() {
    this.getFacilities();
  },
  methods: {
    onHide() {
      this.$emit("closeModalFacility", false);
    },
    getFacilities() {
      axiosF.facilityList(10).then(({ data }) => {
        this.optionsFacility = data;
      });
    },
    onSubmitFacility() {
      this.loading = true;
      const data = {
        FacilityId: this.dataFacility,
        AppointmentId: this.appointmentById?.id,
      };
      axiosA.appointmentChangeFacility(data).then((res) => {
        this.loading = false;
        const { type, message } = NotificationMixin.methods.notificationCheck(
          res
        );
        this.$emit("NotificationCheck", { type, message });
        this.onHide();
      });
    },
  },
};
</script>

<style lang="scss"></style>
